import {
  REQUEST_MONTH_DATA,
  REQUEST_MONTH_DATA_BLOCKED,
  REQUEST_INITIAL_DATA_ANALYSIS,
  REQUEST_DATA_ERROR_ANALYSIS,
  SET_PRICE_SOURCE_ID,
  MONTH_VIEW_PAGE_LOADED,
  RECEIVE_MONTH_DATA,
  RECEIVE_MONTH_DATA_ANALYSIS,
  RECEIVE_PRICE_TRACES,
} from '../../../helpers/constants/actionsConstants';

import type { MonthGridData, PriceTraces } from '../../../selectors/types';

export const requestMonthDataStarted = () => ({
  type: `${REQUEST_MONTH_DATA}_STARTED`,
});

export const requestMonthDataSucceeded = () => ({
  type: `${REQUEST_MONTH_DATA}_SUCCEEDED`,
});

export const requestMonthDataBlocked = () => ({
  type: REQUEST_MONTH_DATA_BLOCKED,
});

export const requestInitialDataAnalytics = () => ({
  type: REQUEST_INITIAL_DATA_ANALYSIS,
});

export const monthViewPageLoaded = () => ({
  type: MONTH_VIEW_PAGE_LOADED,
});

export const setPriceSourceId = (priceSourceId: string) => ({
  type: SET_PRICE_SOURCE_ID,
  payload: priceSourceId,
});

export const requestDataErrorAnalysis = (response: Response) => ({
  type: REQUEST_DATA_ERROR_ANALYSIS,
  payload: {
    url: response.url,
    status: response.status,
  },
});

export const receiveMonthDataStarted = (
  payload: {
    grid: MonthGridData | null;
    url?: string;
    outboundMonth?: Date | null;
  },
  metadata: Record<string, unknown>,
) => ({
  type: `${RECEIVE_MONTH_DATA}_STARTED`,
  payload: [payload, metadata],
});

export const receiveMonthDataAnalytics = (
  callMetadata: Record<string, unknown>,
) => ({
  type: RECEIVE_MONTH_DATA_ANALYSIS,
  meta: {
    callMetadata,
  },
});

export const receivePriceTraces = (traces?: PriceTraces) => ({
  type: RECEIVE_PRICE_TRACES,
  payload: traces,
});
